import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-contraente-type-selector',
  templateUrl: './contraente-type-selector.component.html',
  styleUrls: ['./contraente-type-selector.component.scss']
})
export class ContraenteTypeSelectorComponent implements OnInit {

  constructor(private matDialogRef: MatDialogRef<ContraenteTypeSelectorComponent>) { }

  ngOnInit(): void {
  }

  close(tipo) {
    this.matDialogRef.close(tipo);
  }

}
